import { PostAuditConfigGenerate } from 'domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemotePostAuditConfigGenerate
  extends BaseHttpService<PostAuditConfigGenerate.Model>
  implements PostAuditConfigGenerate
{
  async generate(
    params: PostAuditConfigGenerate.Params
  ): Promise<PostAuditConfigGenerate.Model | HttpGenericErrorResponse> {
    return await this.request('post', params);
  }
}
